module.exports = __webpack_public_path__ + "static/media/read.765f119f.svg";